import { render, staticRenderFns } from "./BenefitsToUse.vue?vue&type=template&id=4ca5e81c&scoped=true&"
import script from "./BenefitsToUse.vue?vue&type=script&lang=js&"
export * from "./BenefitsToUse.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsToUse.vue?vue&type=style&index=0&id=4ca5e81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5e81c",
  null
  
)

export default component.exports